import React, { useContext, useMemo } from 'react';

import { ReactFCC } from '@notino/react-styleguide-v20';

import { IBuildAppSettings } from '@model';

import { ECountryLocale } from '../../../config';

import { useLoadApplicationSettings } from './applicationSettingsUtils';

export interface IApplicationBuildContext {
  settings: IBuildAppSettings;
}

const defaultApplicationSettings: IBuildAppSettings = {
  cdnBaseUrlAddress: '',
  checkoutGatewayBaseUrlAddress: '',
  applicationName: '',
  websiteHostAddress: '',
  domainName: '',
  locale: ECountryLocale.BRITAIN,
  environment: '',
  przelewyPaymentAddress: '',
  googleApiKey: '',
  mapyCzApiKey: '',
  newRelicLicenseKey: '',
  newRelicAppId: '',
  newRelicAccountId: '',
};

export const ApplicationBuildContext = React.createContext<IApplicationBuildContext>({
  settings: defaultApplicationSettings,
});

export const ApplicationBuildContextProvider: ReactFCC = ({ children }) => {
  const {
    cdnBaseUrlAddress,
    checkoutGatewayBaseUrlAddress,
    websiteHostAddress,
    applicationName,
    locale,
    domainName,
    environment,
    przelewyPaymentAddress,
    googleApiKey,
    mapyCzApiKey,
    newRelicLicenseKey,
    newRelicAccountId,
    newRelicAppId,
  } = useLoadApplicationSettings();

  const contextReturnValue = useMemo(() => {
    return {
      settings: {
        cdnBaseUrlAddress,
        checkoutGatewayBaseUrlAddress,
        websiteHostAddress,
        applicationName,
        locale,
        domainName,
        environment,
        przelewyPaymentAddress,
        googleApiKey,
        mapyCzApiKey,
        newRelicLicenseKey,
        newRelicAccountId,
        newRelicAppId,
      },
    };
  }, [
    cdnBaseUrlAddress,
    checkoutGatewayBaseUrlAddress,
    websiteHostAddress,
    applicationName,
    locale,
    domainName,
    environment,
    przelewyPaymentAddress,
    googleApiKey,
    mapyCzApiKey,
    newRelicLicenseKey,
    newRelicAccountId,
    newRelicAppId,
  ]);

  return <ApplicationBuildContext.Provider value={contextReturnValue}>{children}</ApplicationBuildContext.Provider>;
};

export const useApplicationBuildContext = () => useContext(ApplicationBuildContext);
